import React from 'react';
import LogoImage from './logo.svg';

const Logo = () => {
  return <img src={LogoImage} alt="Counted logo" />;
};

export default Logo;
